<template>
	<div class="reply" v-if="reply.operator">
    <div class="header">
      <div class="left">
        <img :src='currentConsultImgSrc' >
        <span class="subject">{{reply.operator.userName}}</span>
        <span class="action">回答</span>
        <span class="title">{{title}}</span>
      </div>
      <div class="right">
        {{ date }}
      </div>
    </div>
    <div class="content showEllipsis">
      <p>{{ reply.reply }}</p>
    </div>
	</div>
</template>

<script>
import { getChatTime } from '@/utils/date'
export default {
  name: 'ReplyBox',
  props: {
    reply: {},
    title: String,
  },

  computed: {
    date() {
      return getChatTime(new Date(this.reply.createTime))
    },
		currentConsultImgSrc() {
			return 'http://sys.rennengda.com/public/images/consult/consult-1.jpg'
		},		    
  },

  methods: {
    handleClick() {
        this.$emit('playMission',this.missionId)
    },
  }
}
</script>

<style lang="stylus" scoped>
.reply
  background-color: #C2E8F1
  margin: 0.16rem 0
  padding: 0.12rem
  line-height :0.36rem
  .header
    display: flex
    overflow: hidden
    .left
      float:left
      img
        width:0.5rem
        height:0.5rem
      .subject
        color:#008DCF
        padding-left:0.12rem
        padding-right:0.12rem
      .action
        color:#999999
        padding-right:0.12rem
      .title
        color:#008DCF
    .right
      margin-left:0.12rem
      float:right
      font-size :0.24rem
      color:#999
  .content
    font-size:0.24rem
    color:#999999
    margin-top:0.1rem
    max-height:0.9rem
    line-height:0.3rem
  .showEllipsis
    overflow: hidden
    // white-space: nowrap
    text-overflow: ellipsis
</style>
